import * as React from "react";
import styled from "styled-components";
import * as sanitizeHtml from "sanitize-html";
import { graphql, useStaticQuery } from "gatsby";
import theme from "../ui/theme";

const NieuwsContainer = styled.div`
  width: 100vw;
  height: auto;
  padding-top: 100px;
  padding-bottom: 200px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;
const NieuwsFrame = styled.div`
  a {
    line-height: 3rem;
    color: white;
    background-color: ${theme.common.blue};
    padding: 7px 10px 7px 10px;
    margin: 20px;
    border-radius: 2px;
    text-decoration: none;
  }
`;

const FotoFrame = styled.div`
  color: white;
  user-select: none;
  div {
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  img {
    width: 70vw;
    height: auto;
    @media only screen and (max-width: 1000px) {
      height: auto !important;
      width: 90vw;
    }
  }
`;

const Kampioenschap = ({ data }) => {
  const queryKampioenschap = useStaticQuery(graphql`
    query allStrapiKampioenschap {
      allStrapiKampioenschap {
        nodes {
          content {
            data {
              content
            }
          }
          subTitel
        }
      }
    }
  `);
  const content = queryKampioenschap.allStrapiKampioenschap.nodes[0];

  const createMarkup = () => {
    var clean = sanitizeHtml(content.content.data.content);
    return { __html: clean };
  };

  const createImageMarkup = () => {
    var clean = sanitizeHtml(content.content.data.content, {
      allowedTags: ["img"],
    });
    return { __html: clean };
  };
  return (
    <>
      <NieuwsContainer>
        <NieuwsFrame>
          <h3>{content.subTitel}</h3>
          <div
            dangerouslySetInnerHTML={createMarkup()}
            className="ckContent"
          ></div>
        </NieuwsFrame>
        <NieuwsFrame>
          <FotoFrame>
            <div
              dangerouslySetInnerHTML={createImageMarkup()}
              className="ckContent"
            ></div>
          </FotoFrame>
        </NieuwsFrame>
      </NieuwsContainer>
    </>
  );
};

export default Kampioenschap;
